<div class="flex flex-col items-center justify-center px-12 text-center text-white w-full h-full">
  <mat-icon [svgIcon]="'wifi_off'" class="text-6xl mb-12 text-danger"></mat-icon>

  <div class="text-2xl font-bold mb-8">Sin conexión a internet</div>

  <div class="text-gray-600">
    Por favor, verifica tu conexión a internet e intenta nuevamente.
  </div>

</div>
